/** model for filters that can be applied to the data */
export interface IFilters {
    minmax: {
        enabled: boolean,
        min: number,
        max: number
    };
    delta: {
        enabled: boolean,
        value: number
    };
    change: {
        enabled: boolean
    };
}

export const DEFAULT_FILTERS: IFilters = {
    minmax: {
        enabled: false,
        min: null,
        max: null
    },
    delta: {
        enabled: false,
        value: null
    },
    change: {
        enabled: false
    }
};
